import { useEffect, useRef, useState } from 'react'

import cn from 'classnames'
import { tr } from 'mmfintech-commons'

import { ArrowRightIcon } from '@icons'
import { PaymentMethodImage } from './PaymentMethodImage'

import './paymentMethodButton.scss'

type PaymentMethodButtonProps = {
  name: string
  description?: string
  onClick: () => void
  onContinue?: () => void
  selected: boolean
  disabled?: boolean
  skipDoubleClickPrevention?: boolean
}

const PaymentMethodButton = (props: PaymentMethodButtonProps) => {
  const { name, description, selected, onClick, onContinue, disabled, skipDoubleClickPrevention } = props

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const [locked, setLocked] = useState<boolean>(false)

  const handleClick = () => {
    if (disabled || locked) return

    if (selected) {
      onContinue?.()
      if (!skipDoubleClickPrevention) {
        setLocked(true)
        timeoutRef.current = setTimeout(() => setLocked(false), 3000)
      }
    } else {
      onClick()
    }
  }

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [])

  return (
    <div
      className={cn('method-button-wrapper', { selected, disabled })}
      onClick={handleClick}
      data-test={`method-${name.toLowerCase()}`}
    >
      <PaymentMethodImage method={name} />
      <div className='button-content'>
        {tr(`METADATA.PAYMENT_OPTIONS.${name}`, name)}
        {description && <div className='description'>{description}</div>}
      </div>
      <div className='button-arrow arrow' data-test={`button-${name.toLowerCase()}`}>
        <ArrowRightIcon />
      </div>
    </div>
  )
}

export default PaymentMethodButton
